define('Components/AboutCornerWidget/js/models/AboutCornerWidgetInstanceModel',['jquery',
        'app',
        'WidgetInstanceModel',
        'UrlFactory'
    ],
    function ($, app, WidgetInstanceModel, UrlFactory) {
        return WidgetInstanceModel.extend({
            name:'AboutCornerWidgetModel',
        
            getSizedImage:function(desktop, mobile) {
                return UrlFactory.getUrlPicture(app.isMobile() ? mobile : desktop,'widget','noscale','widget','jpg');
            },

            getCornersGeoJson: function() {
                var stores = app.getStores(),
                    result = {
                        type: "FeatureCollection",
                        features: []
                    };
                stores.each(function (store) {
                    if (store.isInternational()) { return }
                    if (store.get('template') !== 'corner') { return }

                    var lat = store.getLatitude(), lng = store.getLongitude();
                    
                    if(_.isNaN(lat) || _.isNaN(lng)) {return }
                    var data = {
                        type: "Feature",
                        geometry: {
                            type: "Point",
                            coordinates: [lng, lat]
                        },
                        properties: {
                            shop_type: store.get('template') === 'shop' ? 'store' : store.get('template'),
                            id_store: store.id,
                        }
                    }
                    
                    result.features.push(data)
                });

                return result;
            }
        })
    });
